
import { X, Check } from 'lucide-react';

const BeforeAfterSection = () => {
  return (
    <section className="container max-w-6xl mx-auto px-4 py-24">
      <div className="text-center mb-16">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">
          Before vs
          <span className="block text-yellow-400">After Show Up!</span>
        </h2>
      </div>

      <div className="grid lg:grid-cols-2 gap-12">
        {/* Before */}
        <div className="bg-red-500/10 backdrop-blur-sm rounded-3xl p-8 border border-red-400/20">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <X className="w-8 h-8 text-red-400" />
            </div>
            <h3 className="text-3xl font-black text-red-400 mb-4">Before Show Up!</h3>
          </div>
          
          <div className="space-y-6">
            <div className="bg-red-500/10 rounded-2xl p-6">
              <h4 className="text-xl font-bold text-white mb-3">"I need to build lasting habits"</h4>
              <div className="flex items-center gap-3 text-red-400 font-medium">
                <ArrowDown className="w-5 h-5" />
                <span>Pressure, guilt, failure</span>
              </div>
            </div>
            
            <div className="text-white/80 space-y-3 font-medium">
              <p>• Forever commitments feel overwhelming</p>
              <p>• Breaking streaks leads to shame spirals</p>
              <p>• Complex tracking systems get abandoned</p>
              <p>• All-or-nothing thinking</p>
              <p>• Feeling like you "should" be better</p>
            </div>
          </div>
        </div>

        {/* After */}
        <div className="bg-yellow-400/10 backdrop-blur-sm rounded-3xl p-8 border border-yellow-400/20">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-yellow-400" />
            </div>
            <h3 className="text-3xl font-black text-yellow-400 mb-4">After Show Up!</h3>
          </div>
          
          <div className="space-y-6">
            <div className="bg-yellow-400/10 rounded-2xl p-6">
              <h4 className="text-xl font-bold text-white mb-3">"I'll experiment for 21 days"</h4>
              <div className="flex items-center gap-3 text-yellow-400 font-medium">
                <ArrowUp className="w-5 h-5" />
                <span>Curiosity, learning, growth</span>
              </div>
            </div>
            
            <div className="text-white/80 space-y-3 font-medium">
              <p>• Time-limited commitments feel manageable</p>
              <p>• Ending PACTs brings celebration, not shame</p>
              <p>• Simple yes/no tracking stays sustainable</p>
              <p>• Experimental thinking embraces all outcomes</p>
              <p>• Curious about what you might discover</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Import missing icon
import { ArrowDown, ArrowUp } from 'lucide-react';

export default BeforeAfterSection;
